import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DocumentService } from '../_services/document.services';

@Component({
  selector: 'app-glacier',
  templateUrl: './glacier.component.html',
  styleUrls: ['./glacier.component.scss']
})
export class GlacierComponent implements OnInit {

  glacierDetailsList : any[];
  noDocuments: boolean = false;
  docLength: number;
  docsList: MatTableDataSource<any>;
  documentCols: String[] = ["srNum", "title", "requested_date","user","status","expiration_date"];
  selectedRow: Array<JSON> = [];

  sort;
  @ViewChild(MatSort, { static: false }) set content(content: any) { 
    this.sort = content;
    if (this.sort) {
      this.docsList.sort = this.sort;
    }
  }

  paginator;
  @ViewChild(MatPaginator, { static: false }) set pageContent(content: any) {
    this.paginator = content;
    if (this.paginator) {
      this.docsList.paginator = this.paginator;
    }
  }
  
  constructor(
    private documentService: DocumentService
  ) { }

  ngOnInit() {
    this.getGlacierDocuments();
  }

  getGlacierDocuments() {
    this.documentService.getGlacierStatus()
      .subscribe(docs => {
        this.glacierDetailsList = []
        if (docs == "No Documents requested for retrieval") {
          this.noDocuments = true;
        }
       
        this.glacierDetailsList = docs
        this.docLength = this.glacierDetailsList.length;
        this.docsList = new MatTableDataSource(this.glacierDetailsList);
        this.docsList.sort = this.sort;
        this.docsList.paginator = this.paginator;
      });
  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.docsList.filter = filterValue.trim().toLowerCase();
    if (this.docsList.paginator) {
      this.docsList.paginator.firstPage();
      this.docLength = this.docsList.filteredData.length
    }
  }

}
